export enum EmailType {
  NotSelected = 0,
  Invoice = 1,
  Promo = 2,
  Moderation = 3,
}
